<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <div class="title-separator">
        <h4>{{ $t("components.instructions.title") }}</h4>
      </div>

      <div class="col-md-12">
        <ol>
          <li>
            <p>
              {{ $t("components.instructions.conditions.one") }}
            </p>
          </li>
          <li>
            <p>
              {{ $t("components.instructions.conditions.two") }}
            </p>
          </li>
          <li>
            <p>{{ $t("components.instructions.conditions.three") }}</p>
          </li>
          <li>
            <p>{{ $t("components.instructions.conditions.four") }}</p>
          </li>
          <li>
            <p>{{ $t("components.instructions.conditions.five") }}</p>
          </li>
        </ol>
      </div>

      <div class="col-md-12 my-4">
        <b-button class="play-btn" v-b-modal.modal-center></b-button>
        <p class="text-center mt-3">
          {{ $t("components.instructions.conditions.video_title") }}
        </p>
      </div>

      <b-modal
        id="modal-center"
        :title="$t('components.instructions.conditions.modal_title')"
        title-class="font-18"
        centered
        hide-footer
      >
        <div
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <video
            src="@/assets/video/video.mp4"
            controls
            autoplay
            style="max-height: 100%; max-width: 100%"
          ></video>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- end page title -->
</template>
